import {useState} from 'react'
import {CrudProvider} from '../../../services/loggedin/CrudContext'
import {ChartsComponent} from '../../parts/crud/Charts'
import {useIntl} from 'react-intl'
import {getBaseBarChartOptions} from '../../parts/crud/Types'
import {error} from 'console'
import {DataRangeFilter} from '../../parts/filters/DataRangeFilter'
import {ServerFilter} from '../../parts/filters/ServerFilter'
import moment from 'moment'
import {Form} from 'react-bootstrap'
import {EventCategoryFilter} from '../../parts/filters/EventCategoryFilter'

export const EventsOccurrencies = () => {
  const intl = useIntl()
  const [loading, setLoading] = useState(false)
  const [filterData, setFilterData] = useState(null)
  const [dateRange, setDateRange] = useState({
    start: moment().subtract(6, 'days'),
    end: moment(),
  })
  const [server, setServer] = useState('all')
  const [groupSelected, setGroupSelected] = useState<any>(null)
  const [serversSelected, setServersSelected] = useState([])
  const [error, setError] = useState('')
  const [eventCategory, setEventCategory] = useState(null)
  const [categorySelected, setCategorySelected] = useState<any>(null)
  const [error_category, setErrorCategory] = useState('')
  const [event_is_open, setEventsIsOpen] = useState('1')
  const submitData = async () => {
    let has_error = false
    setError('')
    if (
      server === 'oneormore' &&
      (serversSelected === null || (Array.isArray(serversSelected) && serversSelected.length === 0))
    ) {
      setError(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_SERVER'}))
      has_error = true
    }
    setErrorCategory('')
    if (
      eventCategory === '0' &&
      (categorySelected === null ||
        (Array.isArray(categorySelected) && categorySelected.length === 0))
    ) {
      setErrorCategory(intl.formatMessage({id: 'GENERIC.REQUIRED:SELECT_CATEGORY'}))
      has_error = true
    }
    if (has_error) {
      return
    }
    setErrorCategory('')
    let data: any = {
      date_range: {
        start: dateRange.start.format('YYYY-MM-DD') + ' 00:00:00',
        end: dateRange.end.format('YYYY-MM-DD') + ' 23:59:59',
      },
      server: server,
      group_list: groupSelected ? groupSelected.value : null,
      selected_server:
        server === 'oneormore' && serversSelected
          ? serversSelected.map((srv: any) => srv.value)
          : [],
      tz: new Date().getTimezoneOffset(),
      event_category: eventCategory,
      category_selected:
        categorySelected && eventCategory === '0'
          ? categorySelected.map((cat: any) => cat.value)
          : [],
      event_is_open: event_is_open,
    }
    setFilterData(data)
  }
  let params: any = {
    title: intl.formatMessage({id: 'DIAGNOSTIC.DIAGNOSTIC_EVENTS_OCCURRENCIES.TITLE'}),
    yAxisTitle: intl.formatMessage({id: 'DIAGNOSTIC.DIAGNOSTIC_EVENTS_OCCURRENCIES.YAXISTITLE'}),

    headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
    pointFormat:
      '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
      '<td style="padding:0"><b>{point.y:.0f} </b></td></tr>',
    footerFormat: '</table>',
    shared: true,
    useHTML: true,
  }
  let baseChartOptions: any = {...getBaseBarChartOptions(params)}
  baseChartOptions.plotOptions = {
    column: {
      stacking: 'normal',
      minPointLength: 5,
    },
  }
  baseChartOptions.legend = {
    layout: 'vertical',
    align: 'left',
    verticalAlign: 'top',
    x: 150,
    y: 100,
    title: {
        text: intl.formatMessage({id: 'DIAGNOSTIC.DIAGNOSTIC_EVENTS_OCCURRENCIES.LEGEND_TITLE'})
    },
    floating: true,
    draggable: true,
    borderWidth: 1,
    backgroundColor:  '#FFFFFF'
};
  return (
    <>
      <CrudProvider api='diagnostic/events-occurrencies'>
        <ChartsComponent
          setLoading={(loading) => {
            setLoading(loading)
          }}
          filterData={filterData}
          baseChartOptions={baseChartOptions}
        >
          <p>{intl.formatMessage({id: 'DIAGNOSTIC.DIAGNOSTIC_EVENTS_OCCURRENCIES.TEXT'})}</p>
          <DataRangeFilter
            onChangedDataRange={(start, end) => {
              setDateRange({
                start: start,
                end: end,
              })
            }}
          />
          <ServerFilter
            onChangedServer={(server) => {
              setServer(server)
            }}
            onChangedServersSelected={(servers) => {
              setServersSelected(servers)
            }}
            onGroupSelected={(group) => {
              setGroupSelected(group)
            }}
          />
          {error && <div className='alert alert-danger'>{error}</div>}
          <EventCategoryFilter
            onChangedEventCategory={(eventCategory: any) => {
              setEventCategory(eventCategory)
            }}
            onChangedCategorySelected={(categorySelected: any) => {
              setCategorySelected(categorySelected)
            }}
          />
          {error_category && <div className='alert alert-danger'>{error_category}</div>}
          <label htmlFor='event_is_open' className='fw-bold fs-6'>
            {intl.formatMessage({
              id: 'GENERIC.EVENTS_OF_INTEREST',
            })}
          </label>
          <Form.Check
            type='radio'
            id='event_is_open'
            value='1'
            label={intl.formatMessage({
              id: 'GENERIC.ONLY_PENDING',
            })}
            checked={event_is_open === '1'}
            onChange={(e) => {
              if (e.target.checked) {
                setEventsIsOpen('1')
              }
            }}
            className='mb-2'
          />
          <Form.Check
            type='radio'
            id='event_is_closed'
            value='0'
            label={intl.formatMessage({
              id: 'GENERIC.ONLY_CLOSED',
            })}
            checked={event_is_open === '0'}
            onChange={(e) => {
              if (e.target.checked) {
                setEventsIsOpen('0')
              }
            }}
            className='mb-2'
          />
          <input
            type='button'
            disabled={loading}
            className='btn btn-primary'
            onClick={submitData}
            value={intl.formatMessage({id: 'GENERIC.SUBMIT'})}
            style={{float: 'left'}}
          />{' '}
          {loading && (
            <div
              className='spinner-border text-primary'
              role='status'
              style={{marginTop: '7px', float: 'left', marginLeft: '10px'}}
            >
              <span className='visually-hidden'>Loading...</span>
            </div>
          )}
        </ChartsComponent>
      </CrudProvider>
    </>
  )
}
